import * as React from "react";
import type { SVGProps } from "react";
const SvgIdeal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#ideal_svg__a)">
      <path
        fill="#fff48d"
        d="M21.119 2H2.88a.88.88 0 0 0-.88.881V21.12c0 .486.395.881.881.881H21.12a.88.88 0 0 0 .881-.881V2.88a.88.88 0 0 0-.882-.88"
      />
      <path
        fill="#fff"
        d="M5.831 3.55v9.248a.81.81 0 0 0 .809.805h5.552c4.197 0 6.016-2.339 6.016-5.441s-1.82-5.416-6.017-5.416H6.64a.81.81 0 0 0-.808.805"
      />
      <path
        fill="#c06"
        d="M9.547 5.016v6.833h2.988c2.713 0 3.89-1.526 3.89-3.682 0-2.157-1.178-3.666-3.89-3.666h-2.47a.517.517 0 0 0-.518.515"
      />
      <path
        fill="#232323"
        fillRule="evenodd"
        d="M7.363 12.866h4.828c3.393 0 5.265-1.67 5.265-4.7 0-1.746-.684-4.68-5.265-4.68H7.363a.775.775 0 0 0-.776.773v7.835c0 .427.348.773.776.773M6.845 4.26c0-.285.23-.515.518-.515h4.828c1.867 0 5.005.575 5.005 4.422 0 2.865-1.78 4.443-5.006 4.443H7.364a.515.515 0 0 1-.518-.515z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M11.018 7.173a.8.8 0 0 0-.29-.049V7.12h-.683v1.65h.692q.185-.002.32-.065a.66.66 0 0 0 .36-.44 1.25 1.25 0 0 0-.012-.69.8.8 0 0 0-.154-.253.65.65 0 0 0-.233-.15m-.163 1.272a.5.5 0 0 1-.15.025v.004h-.313v-1.04h.253a.6.6 0 0 1 .217.036c.06.024.107.065.143.11a.5.5 0 0 1 .08.17 1 1 0 0 1 .023.224.7.7 0 0 1-.036.232.5.5 0 0 1-.09.155.3.3 0 0 1-.127.085"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M12.888 7.125v.305h-.847v.354h.78v.28h-.78v.403h.867v.305H11.69v-1.65h1.198z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m14.7 8.775-.602-1.65h-.368l-.605 1.65h.356l.127-.366h.6l.123.366zm-.783-1.244.202.605h-.416l.21-.605z"
        clipRule="evenodd"
      />
      <path fill="#fff" d="M15.273 7.124V8.47h.783v.305h-1.135v-1.65z" />
      <path
        fill="#232323"
        d="M8.159 8.8a.776.776 0 1 0 0-1.552.776.776 0 0 0 0 1.551m.461 3.105c-.6 0-1.082-.519-1.082-1.156v-.903c0-.318.241-.58.543-.58s.543.258.543.58v2.059z"
      />
      <path
        fill="#1d1c1c"
        d="M19.492 15.492H4.575a.136.136 0 0 1-.135-.136c0-.075.06-.136.135-.136H19.49a.136.136 0 0 1 0 .271m-3.552 3.374c0-.907.645-1.733 1.76-1.733s1.764.827 1.764 1.733-.645 1.734-1.764 1.734c-1.115 0-1.76-.828-1.76-1.734m2.545 0c0-.437-.288-.84-.785-.84s-.785.404-.785.84c0 .437.292.841.785.841.492 0 .785-.404.785-.84m-3.231.644c.372-.212.595-.616.595-1.062 0-.663-.479-1.227-1.222-1.227h-1.56v3.289h.966v-.84h.181l.553.84h1.137zm-.822-.598h-.399v-.93h.404c.26 0 .427.212.427.466 0 .253-.172.465-.431.465m-5.775-1.695-.58 1.96-.565-1.96h-.77l-.57 1.96-.575-1.96h-1.02L5.744 20.5h.84l.542-1.787.538 1.787h.843l1.168-3.282zm2.481 2.48h-.003a.75.75 0 0 1-.723-.507h2.455q.03-.163.03-.332c0-.904-.644-1.73-1.76-1.73v.89a.75.75 0 0 1 .722.508H9.407q-.03.163-.03.332c0 .905.644 1.73 1.757 1.73h.002z"
      />
      <path
        fill="url(#ideal_svg__b)"
        d="M11.134 20.59q.057 0 .112-.004a1.9 1.9 0 0 0 .614-.131 1.63 1.63 0 0 0 .817-.727c.08-.144.138-.302.175-.465h-1.024a.73.73 0 0 1-.582.428 1 1 0 0 1-.111.007.74.74 0 0 1-.55-.227l-.664.672c.295.273.705.445 1.214.445z"
      />
      <path
        fill="url(#ideal_svg__c)"
        d="M11.134 17.128c-.944 0-1.55.594-1.712 1.326h1.02a.75.75 0 0 1 .692-.435c.264 0 .469.114.602.286l.672-.679c-.3-.303-.731-.498-1.273-.498"
      />
    </g>
    <defs>
      <linearGradient
        id="ideal_svg__b"
        x1={12.352}
        x2={10.826}
        y1={18.667}
        y2={20.536}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.02} stopColor="#1d1c1c" stopOpacity={0} />
        <stop offset={0.68} stopColor="#1d1c1c" />
      </linearGradient>
      <linearGradient
        id="ideal_svg__c"
        x1={9.69}
        x2={11.255}
        y1={19.064}
        y2={17.517}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.02} stopColor="#1d1c1c" stopOpacity={0} />
        <stop offset={0.68} stopColor="#1d1c1c" />
      </linearGradient>
      <clipPath id="ideal_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIdeal;
